import React from 'react'
import { HomeEducationalAction } from '../HomeEducationalService/HomeEducationalService'
import ThreeColumnSection from '../ThreeColumnSection/ThreeColumnSection'
import { EducationalHighlight } from '../../generated/graphql'

interface HomeEducationalServiceDesktopProps {
    content: EducationalHighlight[]
    action: HomeEducationalAction
}

export default function HomeEducationalServiceDesktop(props: HomeEducationalServiceDesktopProps) {
    const { content, action } = props
    return <ThreeColumnSection content={content} action={action} />
}
